export enum ModalButtonStateEnum {
    Open = 'open',
    Close = 'close',
}

export enum ModalStyleEnum {
    Normal = 'normal',
    Alert = 'alert',
}
